import { Link } from "react-router-dom";
import { ArrowRight, BadgeDollarSign, Laptop, Clock3, MapPinned } from "lucide-react";
import QuickMatchForm from "../QuickMatchForm";

const CHIPS = [
  { Icon: BadgeDollarSign, t: "$0 — free for job seekers" },
  { Icon: Laptop, t: "100% remote roles" },
  { Icon: Clock3, t: "Real reply in 2 business days" },
  { Icon: MapPinned, t: "Hiring in all 50 states" },
];

export default function HomeHero({ cats, total }) {
  return (
    <section className="relative overflow-hidden bg-[#0F2A1F] text-white pt-28 pb-14 md:pt-36 md:pb-24" data-testid="home-hero">
      <div aria-hidden className="pointer-events-none absolute inset-0 hero-glow" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-x-14 gap-y-8 items-start">
        <div className="lg:col-span-7 lg:row-start-1 fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 ring-1 ring-white/15 px-3.5 py-1.5 text-xs font-semibold" data-testid="hero-live-pill">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#10B981] opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#10B981]" />
            </span>
            {total > 0 ? `${total.toLocaleString()} remote roles open right now` : "Remote roles open right now"}
          </div>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.02] tracking-tight">
            Skip the job-board black hole.{" "}
            <span className="text-[#D4AF37] italic">Get hired from home.</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-white/75 max-w-xl leading-relaxed">
            Tell us who you are in 30 seconds. A real recruiter matches you with US employers hiring <em>this week</em> — across 11 career fields, entry-level to senior.
          </p>
        </div>

        <div className="lg:col-span-5 lg:col-start-8 lg:row-start-1 lg:row-span-2 fade-up" style={{ animationDelay: "120ms" }}>
          <QuickMatchForm cats={cats} />
        </div>

        <div className="lg:col-span-7 lg:row-start-2 fade-up" style={{ animationDelay: "220ms" }}>
          <ul className="grid grid-cols-2 gap-2.5 sm:gap-3 max-w-xl" data-testid="hero-trust-chips">
            {CHIPS.map(({ Icon, t }) => (
              <li key={t} className="flex items-center gap-2 rounded-xl bg-white/[0.06] ring-1 ring-white/10 px-3 py-2.5 text-[13px] sm:text-sm font-medium">
                <Icon className="h-4 w-4 shrink-0 text-[#D4AF37]" /> {t}
              </li>
            ))}
          </ul>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/jobs" className="h-12 inline-flex items-center gap-2 rounded-xl bg-white text-[#0F2A1F] px-6 text-sm font-semibold hover:bg-[#FAF7EE] transition-colors" data-testid="hero-browse-jobs">
              Browse all jobs <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/for-employers" className="h-12 inline-flex items-center gap-2 rounded-xl ring-1 ring-white/25 px-6 text-sm font-semibold hover:bg-white/10 transition-colors" data-testid="hero-hire-talent">
              I'm hiring
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
